<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title px-1 pt-2 w-100">
        <div [ngClass.sm]="'row flex-column justify-content-center align-items-center'" [ngClass.md]="'row'">
          <div [ngClass.xl]="'float-left'" [ngClass.sm]="'mb-1 col-12'" [ngClass.md]="'col-3'">
            <label class="d-flex align-items-center">
              <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" />
            </label>
          </div>
          <div [ngClass.xl]="'float-right d-inline-block'" [ngClass.md]="'col-3 text-right'" [ngClass.sm]="'col-12 text-right'">
            <a class="btn btn-outline-primary text-primary" (click)="modalOpen(modalCategoryAdd, null)" *ngIf="_authenticationService.hasCapability('create_asset_category')">{{ "ADD" | translate }}</a>
          </div>
          <div [ngClass.xl]="'float-right'" [ngClass.md]="'col-3 offset-3'" [ngClass.sm]="'d-none'">
            <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.sm]="'mb-3'">
              <label class="d-flex align-items-center mb-0"
                >{{ "SHOW" | translate }}
                <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body p-0">
        <div class="d-flex mb-075 pl-1">
          <div class="font-weight-bolder" [ngClass.xl]="'flex-basis-80'" [ngClass.sm]="'flex-basis-70'" [ngClass.md]="'flex-basis-70'">{{ "CATEGORY" | translate }}</div>
          <div class="font-weight-bolder" [ngClass.xl]="'flex-basis-20'" [ngClass.sm]="'flex-basis-10'" [ngClass.md]="'flex-basis-10'">{{ "ACTIONS" | translate }}</div>
        </div>
        <div class="col-12" *ngFor="let category of categoriesFilterList() | slice: (pageBasicText - 1) * pageSize : pageBasicText * pageSize">
          <div class="row border-top d-flex align-items-center p-1">
            <div [ngClass.xl]="'flex-basis-80'" [ngClass.sm]="'flex-basis-70'" [ngClass.md]="'flex-basis-70'" [ngbTooltip]="category.description">{{ category.name }}</div>
            <div [ngClass.xl]="'flex-basis-20'" [ngClass.sm]="'flex-basis-10 d-flex'" [ngClass.md]="'flex-basis-10 d-flex'">
              <button class="bg-transparent border-0 text-secondary pr-1" (click)="modalOpen(modalCategoryEdit, category)" *ngIf="_authenticationService.hasCapability('edit_asset_category')">
                <i [data-feather]="'edit-2'" size="19"></i>
              </button>
              <button *ngIf="!category.child && _authenticationService.hasCapability('delete_asset_category')" (click)="deleteCategory(category)" class="bg-transparent border-0 text-danger remove-item">
                <i [data-feather]="'trash-2'" size="19"></i>
              </button>
            </div>
          </div>
          <div class="row border-top p-1" *ngFor="let child of category.child">
            <div [ngClass.xl]="'flex-basis-80'" [ngClass.sm]="'flex-basis-70'" [ngClass.md]="'flex-basis-70'" [ngbTooltip]="child.description">
              <p class="m-0 p-0">&#8211;&nbsp;&nbsp;{{ child.name }}</p>
            </div>
            <div [ngClass.xl]="'flex-basis-20'" [ngClass.sm]="'flex-basis-10 d-flex'" [ngClass.md]="'flex-basis-10 d-flex'">
              <button class="bg-transparent border-0 text-secondary pr-1" (click)="modalOpen(modalCategoryEdit, child)" *ngIf="_authenticationService.hasCapability('edit_asset_category')">
                <i [data-feather]="'edit-2'" size="19"></i>
              </button>
              <button (click)="deleteCategory(child)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_asset_category')">
                <i [data-feather]="'trash-2'" size="19"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-12" *ngIf="!categoriesList || categoriesList.length < 1">
          <div class="row border-top d-flex align-items-center p-1">
            {{ "NO_DATA_TO_DISPLAY" | translate }}
          </div>
        </div>
      </div>
      <div class="d-flex m-1" [ngClass.xl]="'justify-content-end'" [ngClass.sm]="'justify-content-center'" [ngClass.md]="'justify-content-center'" *ngIf="categoriesFilterList().length > 0">
        <ngb-pagination [pageSize]="pageSize" [collectionSize]="categoriesFilterList().length" [(page)]="pageBasicText" aria-label="Custom pagination">
          <ng-template ngbPaginationPrevious>
            <span [data-feather]="'chevron-left'" [size]="'18'" class="font-weight-bolder"></span>
          </ng-template>
          <ng-template ngbPaginationNext>
            <span [data-feather]="'chevron-right'" [size]="'18'" class="font-weight-bolder"></span>
          </ng-template>
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>

<!-- Modal Edit -->
<ng-template #modalCategoryEdit let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "EDIT" | translate }} {{ "CATEGORY" | translate }}</h3>
    <div class="form-group">
      <label [for]="'newCategory'">{{ "CATEGORY" | translate }}<sup class="text-danger">*</sup></label>
      <input name="newCategory" [(ngModel)]="currentCategory.name" type="text" [id]="'newCategory'" class="form-control" />
      <div class="font-error" *ngIf="showModalErrors && (!currentCategory.name || currentCategory.name.length < 1)">{{ "ERRORS.FIELD_CATEGORY" | translate }}</div>
      <div class="font-error" *ngIf="showModalErrors && !!currentCategory.name && currentCategory.name.length < 2">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
    </div>
    <div class="form-group">
      <label [for]="'currentDescription'">{{ "DESCRIPTION" | translate }}</label>
      <textarea class="form-control" name="currentDescription" id="currentDescription" cols="45" rows="3" [(ngModel)]="currentCategory.description"></textarea>
    </div>
    <div class="custom-control custom-control-primary custom-switch d-flex mt-1" *ngIf="!currentCategory.child">
      <small class="mr-1">{{ "INSERT_AS_A_CHILD" | translate }}</small>
      <input type="checkbox" class="custom-control-input" id="editIsAChild" [(ngModel)]="currentCategory.isAChild" />
      <label class="custom-control-label" for="editIsAChild"> </label>
    </div>
    <div class="form-group mb-1 mt-1" *ngIf="currentCategory.isAChild">
      <label [for]="'editParent'">{{ "SELECT_PARENT" | translate }}<sup class="text-danger">*</sup></label>
      <ng-select
        [(ngModel)]="currentCategory.parent_id"
        id="editParent"
        [bindLabel]="'name'"
        [bindValue]="'id'"
        [searchable]="true"
        [closeOnSelect]="true"
        [clearable]="false"
        [openOnEnter]="false"
        [virtualScroll]="true"
        [items]="categoriesList"
      >
      </ng-select>
      <div class="font-error" *ngIf="showModalErrors && (!currentCategory.parent_id || currentCategory.parent_id < 1)">{{ "ERRORS.FIELD_CATEGORY_PARENT" | translate }}</div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "ALERT.BTN_CANCEL" | translate }}
    </button>
    <button (click)="editCategory()" type="button" class="btn btn-primary w-150" rippleEffect>
      {{ "EDIT" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal Edit -->

<!-- Modal Add -->
<ng-template #modalCategoryAdd let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "ADD" | translate }} {{ "CATEGORY" | translate }}</h3>
    <div class="form-group">
      <label [for]="'newCategory'">{{ "CATEGORY" | translate }}<sup class="text-danger">*</sup></label>
      <input name="newCategory" [(ngModel)]="newCategory" type="text" [id]="'newCategory'" class="form-control" />
      <div class="font-error" *ngIf="showModalErrors && (!newCategory || newCategory.length < 1)">{{ "ERRORS.FIELD_CATEGORY" | translate }}</div>
      <div class="font-error" *ngIf="showModalErrors && !!newCategory && newCategory.length < 2">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
    </div>
    <div class="form-group">
      <label [for]="'newCategoryDescription'">{{ "DESCRIPTION" | translate }}</label>
      <textarea class="form-control" name="newCategoryDescription" id="newCategoryDescription" cols="45" rows="3" [(ngModel)]="newCategoryDescription"></textarea>
    </div>
    <div class="custom-control custom-control-primary custom-switch d-flex mt-1">
      <small class="mr-1">{{ "INSERT_AS_A_CHILD" | translate }}</small>
      <input type="checkbox" class="custom-control-input" id="isAChild" [(ngModel)]="isAChild" />
      <label class="custom-control-label" for="isAChild"> </label>
    </div>
    <div class="form-group mb-1 mt-1" *ngIf="isAChild">
      <label [for]="'parent'">{{ "SELECT_PARENT" | translate }}<sup class="text-danger">*</sup></label>
      <ng-select
        [(ngModel)]="selectedAsAParent"
        id="parent"
        [bindLabel]="'name'"
        [bindValue]="'id'"
        [searchable]="true"
        [closeOnSelect]="true"
        [clearable]="false"
        [openOnEnter]="false"
        [virtualScroll]="true"
        [items]="categoriesList"
      >
      </ng-select>
      <div class="font-error" *ngIf="showModalErrors && (!selectedAsAParent || selectedAsAParent < 1)">{{ "ERRORS.FIELD_CATEGORY_PARENT" | translate }}</div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "ALERT.BTN_CANCEL" | translate }}
    </button>
    <button (click)="addCategory()" type="button" class="btn btn-primary w-150" rippleEffect>{{ "SEND" | translate }}/{{ "ERRORS.INSERT" | translate }}</button>
  </div>
</ng-template>
<!-- / Modal Add -->
